import { snapshot } from 'valtio'
import { buildAxiosInstance } from '../../../../shared/utils/apiUtils'
import { recurringPaymentProxy } from '../../../../shared/proxies/recurringPaymentProxy'
import { convertFromCentValue } from '../../../../shared/utils/formattingUtils'
import { type RpOccurrence } from './rp-occurrence/rpOccurrenceProxy'

interface Response {
  data: {
    pagination: {
      limit: number
      offset: number
      totalCount: number
    }
    rpOccurrences: RpOccurrence[]
  }
  error: string | null
}
export async function executeRpOccurrenceSearch (id: string): Promise<void> {
  const { pagination } = snapshot(recurringPaymentProxy)

  recurringPaymentProxy.relatedApiCall.loading = true
  recurringPaymentProxy.relatedApiCall.error = null

  try {
    const response = await buildAxiosInstance().post<Response>('/api/rp_occurrences/search', {
      limit: pagination.limit,
      offset: pagination.offset,
      recurringPaymentId: String(id)
    })

    if (response.data.error) {
      recurringPaymentProxy.relatedApiCall.error = response.data.error
    } else {
      const rpOccurrences = response.data?.data?.rpOccurrences ?? []

      rpOccurrences.forEach(occ => {
        occ.amountCents = convertFromCentValue(occ.amountCents, occ.amountCurrencyType)

        if (occ.transactions) {
          occ.transactions.forEach(txn => {
            txn.amountCents = convertFromCentValue(txn.amountCents, txn.amountCurrencyType)
            txn.remainingAmountCents = convertFromCentValue(txn.remainingAmountCents, txn.remainingAmountCurrencyType)
          })
        }
      })

      recurringPaymentProxy.rpOccurrences = rpOccurrences
      recurringPaymentProxy.pagination = response.data.data.pagination
    }
  } catch (e) {
    if (e instanceof Error) {
      recurringPaymentProxy.relatedApiCall.error = e.message
    }
  } finally {
    recurringPaymentProxy.relatedApiCall.loading = false
  }
}
